<template>
  <div id="app">
    <router-view />
    <portal-target name="modal" multiple />
    <Dialog
      v-if="!!errorMessages"
      :title="errorTitle"
      :message="errorMessages"
      okText="閉じる"
      @ok="closeErrorModal"
      @close="closeErrorModal"
    />
    <LoadingIndicator v-if="app.busy" />
  </div>
</template>

<script>
import Vue from 'vue'
import PortalVue from 'portal-vue'
import { invoke } from 'lodash'
import { getAppVersion, isWebView } from '@/utils/device'
import { addClass } from '@/utils/dom'
import Dialog from '@/components/molecules/ModalDialog'
import LoadingIndicator from '@/components/molecules/LoadingIndicator'
import { mapState } from 'vuex'

Vue.config.productionTip = false

Vue.use(PortalVue)

export default {
  name: 'App',
  components: {
    Dialog,
    LoadingIndicator,
    // eslint-disable-next-line vue/no-unused-components
    PortalVue,
  },
  computed: {
    ...mapState({
      app: state => state.app,
    }),
    errorTitle() {
      return this.app.status === 503 ? '現在メンテナンス中です' : 'エラー'
    },
    errorMessages() {
      return this.app.errorMessage && this.app.errorMessage.join('\n')
    },
    isApp() {
      return getAppVersion() >= '1.1.1'
    },
  },
  created() {
    if (this.isApp) addClass(document.documentElement, 'app')
  },
  methods: {
    async closeErrorModal() {
      if (this.app.status === 401 && (await this.$store.dispatch('app/logout'))) {
        if (isWebView()) {
          invoke(window, 'webkit.messageHandlers.setUserId.postMessage', '')
          invoke(window, 'webkit.messageHandlers.setPassword.postMessage', '')
        }
        const login = this.app.isSP ? '/sp/login' : '/login'
        location.replace(login)
      }
      this.$store.commit('app/error')
    },
  },
}
</script>

<style src="@css/module/base/reset.css"></style>
<style lang="postcss">
html,
body,
#app {
  height: 100%;
}

body {
  background-color: var(--very-light-gray-4);
  color: var(--text-color);
  font-family: 'ヒラギノ角ゴ Pro W3', 'Hiragino Kaku Gothic Pro', 'メイリオ', Meiryo, 'ＭＳ Ｐゴシック', Helvetica,
    Arial, sans-serif;
  font-size: 15px;
  line-height: 1.6;
  min-width: 1024px;
  position: relative;
  -webkit-text-size-adjust: 100%;
  -webkit-touch-callout: none;
  word-break: break-all;

  &::-webkit-scrollbar {
    display: none;
  }
}

.responsive {
  body,
  #app {
    min-height: 480px;
    min-width: 320px;
  }
}

.app {
  height: 100vh;
}

a,
a:link {
  color: var(--moderate-blue);
}
</style>
